/**
 * Product Card Hover Background Effect
 * Changes the section background color when hovering over product cards
 * Color is read from product metafield: product.metafields.custom.hover_bg_color
 */

class ProductCardHover {
  constructor() {
    this.containers = new Map();
    this.init();
  }

  init() {
    // Find all product cards with hover background color
    const productCards = document.querySelectorAll('product-card[data-hover-bg]');

    productCards.forEach(card => {
      const hoverColor = card.getAttribute('data-hover-bg');
      if (!hoverColor) return;

      // Find the closest section container (look for section IDs or common section classes)
      const container = card.closest('[id^="section-"]')
        || card.closest('[id^="shopify-section-"]')
        || card.closest('.section-margin')
        || card.closest('.template-collection')
        || card.closest('#main-content');

      if (!container) return;

      // Store original background once per container
      if (!this.containers.has(container)) {
        const originalBg = getComputedStyle(container).backgroundColor;
        this.containers.set(container, {
          originalBg: originalBg,
          activeCards: 0
        });

        // Ensure container has transition styles
        container.style.transition = 'background-color 0.5s ease';
      }

      const containerData = this.containers.get(container);

      // Mouse enter - change background
      card.addEventListener('mouseenter', () => {
        containerData.activeCards++;
        container.style.backgroundColor = hoverColor;
      });

      // Mouse leave - restore background only if no other cards are hovered
      card.addEventListener('mouseleave', () => {
        containerData.activeCards--;
        if (containerData.activeCards <= 0) {
          containerData.activeCards = 0;
          container.style.backgroundColor = containerData.originalBg;
        }
      });
    });
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new ProductCardHover());
} else {
  new ProductCardHover();
}

// Re-initialize after Shopify section refresh (theme editor)
document.addEventListener('shopify:section:load', () => new ProductCardHover());
